<template>
  <div class="home bg bg--smb">
    <div class="error-box">
      Sorry Mario, your princess is in <router-link class="error-box__link" to="/">another castle</router-link>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Page not Found',
    meta: [
      { name: 'prerender-status-code', content: '404' },
    ],
  },
};
</script>


<style scoped>
.error-box {
  padding: 10px;
  text-align: center;
  background: #fffded;
  color: #591d1b;
  border-radius: 6px;
  padding: 20px;
}

.error-box__link {
  color: currentColor;
  text-decoration: underline;
  font-weight: bold;
}
</style>
